export default function (fn) {
  var defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function () {
    return setTimeout(fn, 0);
  };

  return defer(fn);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-mask/es/utils/defer.js
// module id = ./node_modules/react-input-mask/es/utils/defer.js
// module chunks = 0